import { useState, useEffect, useRef } from "react";

const PopupModule = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [termsChecked, setTermsChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const hasAccepted = localStorage.getItem("hasAcceptedTerms");
    if (!hasAccepted) {
      setIsVisible(true);
    }
  }, []);

  useEffect(() => {
    setIsButtonDisabled(!(termsChecked && privacyChecked));
  }, [termsChecked, privacyChecked]);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = contentRef.current;
    if (target) {
      const { scrollTop, clientHeight, scrollHeight } = target;
      if (scrollTop + clientHeight >= scrollHeight) {
        setTermsChecked(true);
        setPrivacyChecked(true);
      }
    }
  };

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checkboxType: string,
  ) => {
    const isChecked = e.target.checked;
    if (checkboxType === "terms") {
      setTermsChecked(isChecked);
    } else if (checkboxType === "privacy") {
      setPrivacyChecked(isChecked);
    }
  };

  const handleAccept = () => {
    localStorage.setItem("hasAcceptedTerms", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="w-full max-w-[500px] bg-[#1D1D1D] border border-[#292929] rounded-[8px] p-8">
        <h2 className="text-white text-[24px] -mb-1 font-normal opacity-40">Welcome to</h2>
        <h1 
          className="text-white text-[32px] leading-[110%] tracking-tight login-heading mb-6"
        >
          Sourceful Energy
        </h1>
        
        <div
          onScroll={handleScroll}
          ref={contentRef}
          className="text-[#666666] text-[14px] font-normal font-inter space-y-4 max-h-[300px] overflow-auto pr-2"
        >
          By proceeding, you acknowledge that you have reviewed and consent to
          our{" "}
          <a
            className="text-[#00CC6A] hover:text-[#00B058] transition-colors"
            href="https://docs.sourceful.energy/sourceful-terms/terms"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </a>{" "}
          and{" "}
          <a
            className="text-[#00CC6A] hover:text-[#00B058] transition-colors"
            href="https://docs.sourceful.energy/sourceful-terms/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          , which cover the ways we collect, use, share, and protect your personal
          information, as well as the limitations of our liability. Your
          agreement is necessary to use our services. I confirm that I am over
          the age of consent in my jurisdiction, have read, and fully agree to
          the Terms of Service and Privacy Policy.
        </div>

        <div className="mt-8 space-y-4">
          <div className="flex items-center">
            <input
              type="checkbox"
              checked={termsChecked}
              onChange={(e) => handleCheckboxChange(e, "terms")}
              className="mr-3 h-4 w-4 rounded border-[#292929] bg-[#131313] accent-[#00FF84] checked:border-[#00FF84]"
            />
            <label className="text-[#666666] text-[14px] font-normal font-inter">
              I agree to the Terms and Conditions
            </label>
          </div>
          <div className="flex items-center">
            <input
              type="checkbox"
              checked={privacyChecked}
              onChange={(e) => handleCheckboxChange(e, "privacy")}
              className="mr-3 h-4 w-4 rounded border-[#292929] bg-[#131313] accent-[#00FF84] checked:border-[#00FF84]"
            />
            <label className="text-[#666666] text-[14px] font-normal font-inter">
              I agree to the Privacy Policy
            </label>
          </div>
        </div>

        <button
          className={`w-full mt-8 py-4 px-6 rounded-xl font-normal font-inter transition-opacity
            ${isButtonDisabled 
              ? "bg-[#131313] text-[#666666] cursor-not-allowed" 
              : "bg-[#00FF84] text-[#2B2B2B] hover:opacity-90"
            }`}
          onClick={handleAccept}
          disabled={isButtonDisabled}
        >
          I Accept
        </button>
      </div>
    </div>
  );
};

export default PopupModule;
